import * as LaunchDarkly from 'ldclient-js';

interface FeatureFlagManagerProps {
    userInfo: IUserInfo;
    featureFlagServiceKey: string;
}

class FeatureFlagManager {

    _ldclient: LaunchDarkly.LDClient;
    _initialized: boolean = false;
    _loading: Promise<boolean>;

    constructor(props: FeatureFlagManagerProps) {
        const user = {
            key: `${props.userInfo.masterAccountId} ${props.userInfo.userId}`,
            custom: {
                accountName: props.userInfo.masterAccountName
            }
        };
        const self = this;
        this._ldclient = LaunchDarkly.initialize(props.featureFlagServiceKey, user);
        this._loading = new Promise((resolve) => {
            self._ldclient.on('ready', () => {
                self._initialized = true;
                resolve(true);
            });
        });
    }

    async isFeatureFlagOn(flagKey: string): Promise<boolean> {
        if (!this._initialized) {
            await this._loading;
        }
        return this._ldclient.variation(flagKey, false);
    }
}

export { FeatureFlagManager };
export default FeatureFlagManager;